import React from "react";
import { useTranslation } from "react-i18next";

export interface SkipNavigationProps {
  links?: Array<{
    href: string;
    label: string;
  }>;
}

export const SkipNavigation: React.FC<SkipNavigationProps> = ({ links }) => {
  const { t } = useTranslation();

  const defaultLinks = [
    {
      href: "#main-content",
      label: t("skipNavigation.mainContent", {
        defaultValue: "Skip to main content",
      }),
    },
    {
      href: "#main-navigation",
      label: t("skipNavigation.navigation", {
        defaultValue: "Skip to navigation",
      }),
    },
  ];

  const skipLinks = links || defaultLinks;

  return (
    <div className="sr-only focus-within:not-sr-only">
      <ul className="fixed top-0 left-0 z-50 flex flex-col gap-2 p-4 bg-[var(--color-bg-surface)] border-b border-[var(--color-border-subtle)] shadow-lg">
        {skipLinks.map(link => (
          <li key={link.href}>
            <a
              href={link.href}
              className="inline-block px-4 py-2 text-sm font-medium text-white bg-orange-500 rounded-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:bg-orange-600 transition-colors"
              onFocus={() => {
                // Ensure the skip link is visible when focused
                const element = document.querySelector(link.href);
                if (element) {
                  (element as HTMLElement).scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }
              }}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
